module.exports = __webpack_public_path__ + "img/QQ.71b157ca.png";